var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 4.813a10.72 10.72 0 0 1 9.75 6.267l.158.364.008.02c.128.346.128.727 0 1.073l-.008.02a10.72 10.72 0 0 1-9.907 6.63 10.72 10.72 0 0 1-9.916-6.65 1.54 1.54 0 0 1 0-1.073l.008-.02A10.72 10.72 0 0 1 12 4.814m0 1.2a9.52 9.52 0 0 0-8.792 5.872.34.34 0 0 0 0 .23 9.518 9.518 0 0 0 17.584 0 .34.34 0 0 0 0-.23A9.52 9.52 0 0 0 12 6.012m0 2.564a3.424 3.424 0 1 1 0 6.848 3.424 3.424 0 0 1 0-6.848m0 1.2a2.225 2.225 0 1 0 .002 4.448A2.225 2.225 0 0 0 12 9.776"
  })));
};
export default SvgEye;